// extracted by mini-css-extract-plugin
module.exports = {"root":"MedicalHistory_root__bM1Qp"};